import { AppSettings } from '.';

export const loadAppSettings = async (): Promise<AppSettings> => {
  const appSettings = await fetchAppSettings(
    '/appsettings' +
      (process.env.REACT_APP_ENV ? '.' + process.env.REACT_APP_ENV : '') +
      '.json'
  );

  return appSettings;
};

async function fetchAppSettings(filename: string): Promise<AppSettings> {
  const response = await fetch(filename);
  const json = await response.json();
  return json as unknown as AppSettings;
}
